module.exports = __webpack_public_path__ + "static/media/three_point_five.1e88c295.png";